import { layoutSessions } from "./calendarLayout";
import SessionBlock from "./SessionBlock";
import classes from "./SessionsCalendar.module.css";

/** One location's column: its session blocks and, on today, the now line. */
export default function CalendarColumn({
  column,
  day,
  startHour,
  height,
  nowTop,
  withNowDot,
  sessionProps,
}) {
  return (
    <div className={classes.columnCell} style={{ height }}>
      {layoutSessions(column.sessions, day).map((block) => (
        <SessionBlock
          key={block.session.id}
          block={block}
          column={column}
          day={day}
          startHour={startHour}
          {...sessionProps}
        />
      ))}
      {/* After the blocks so it draws over them */}
      {nowTop !== null && (
        <div
          className={classes.nowLine}
          style={{ top: nowTop }}
          title="Current time (your local time)"
        >
          {withNowDot && <div className={classes.nowDot} />}
        </div>
      )}
    </div>
  );
}
